import { bindActionCreators } from 'redux';

import { createAppSlice } from '@exp/redux/createAppSlice';

import {
  getOrganization,
  getProductPreview,
} from '../js/common/api';
import {
  fetchProductSuggestions,
  fetchRatingSummary,
  setRatingSummary,
} from '../product/productDetailsActions';

const initialState = {
  organization: null,
  productInfo: null,
  error: false,
  suggestions: [],
};

const productUngatedReducer = createAppSlice({
  name: 'productUngated',
  initialState,
  reducers: (create) => ({
    fetchOrganization: create.asyncThunk(
      (organizationId) => getOrganization(organizationId),
      {
        fulfilled: (state, action) => {
          [state.organization] = action.payload.data.organizations;
        },
      },
    ),

    fetchProductPreview: create.asyncThunk(
      ({ organizationId, productCode }) => getProductPreview(organizationId, productCode),
      {
        fulfilled: (state, action) => {
          state.productInfo = action.payload.data;
        },
        rejected: (state) => {
          state.error = true;
        },
      },
    ),

    setProductPreview: create.asyncThunk(
      (productInfo) => productInfo,
      {
        fulfilled: (state, action) => {
          state.productInfo = action.payload;
        },
      },
    ),
  }),

  extraReducers: (builder) => {
    builder.addCase(fetchProductSuggestions.fulfilled, (state, action) => {
      state.suggestions = action.payload.data.resultItems;
    });
  },
});

export const {
  fetchOrganization,
  fetchProductPreview,
  setProductPreview,
} = productUngatedReducer.actions;

export { fetchProductSuggestions, fetchRatingSummary, setRatingSummary };

export const productUngatedActionsDispatch = (dispatch) => bindActionCreators({
  fetchOrganization,
  fetchProductPreview,
  fetchProductSuggestions,
  fetchRatingSummary,
  setProductPreview,
  setRatingSummary,
}, dispatch);

export default productUngatedReducer.reducer;
